import { combineEpics } from "redux-observable";
import { signInWithGoogleEpic, signOutEpic } from "../redux/ducks/auth";
import { fetchModesEpic } from "../redux/ducks/modes";

export default combineEpics(
  ...[signInWithGoogleEpic, signOutEpic, fetchModesEpic]
);
